let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("96SyS")).then(() => parcelRequire('kZTp2'));